import { createRoute } from '@tanstack/react-router';
import { z } from 'zod';
import LoginPage from '@/features/auth/login/pages/LoginPage.tsx';
import { authRoute } from '@/App.tsx';

const searchSchema = z.object({
  redirect: z.string().optional(),
  emailVerified: z.boolean().optional(),
});

export const loginRoute = createRoute({
  getParentRoute: () => authRoute,
  path: '/login',
  component: LoginPage,
  validateSearch: searchSchema,
});
